<app-header
    title="Tools"
    subtitle="Lorem ipsum"
></app-header>
<div class="content-wrapper content-min-height">
    
</div>
<app-footer></app-footer>